<template>
    <div class="clusters-page">
        
        <router-link to="/primer">&#60; BACK</router-link>

        <div class="tab">
            <button class="secondary-btn tablinks" v-on:click="openTab($event, 'osg')">OSG</button>
            <button class="secondary-btn tablinks" v-on:click="openTab($event, 'oet')">OET</button>
            <button class="secondary-btn tablinks" v-on:click="openTab($event, 'comms')">Comms</button>
            <button class="secondary-btn tablinks" v-on:click="openTab($event, 'hr')">HR</button>
            <button class="secondary-btn tablinks" v-on:click="openTab($event, 'marketing')">Marketing</button>
            <button class="secondary-btn tablinks" v-on:click="openTab($event, 'events')">Events</button>
            <button class="secondary-btn tablinks" v-on:click="openTab($event, 'eservs')">eServs</button>
        </div>

        <div id="osg" class="tabcontent">
            <PrimerOSG/>
        </div>

        <div id="oet" class="tabcontent">
            <PrimerOET/>
        </div>

        <div id="comms" class="tabcontent">
            <PrimerComms/>
        </div>

        <div id="hr" class="tabcontent">
            <PrimerHR/>
        </div>

        <div id="marketing" class="tabcontent">
            <PrimerMarketing/>
        </div>

        <div id="events" class="tabcontent">
            <PrimerEvents/>
        </div>

        <div id="eservs" class="tabcontent">
            <PrimerEservs/>
        </div>


        
        
    </div>
</template>

<script>


import PrimerOSG from '../components/cluster-specific/PrimerOSG.vue'
import PrimerOET from '../components/cluster-specific/PrimerOET.vue'
import PrimerComms from '../components/cluster-specific/PrimerComms.vue'
import PrimerMarketing from '../components/cluster-specific/PrimerMarketing.vue'
import PrimerHR from '../components/cluster-specific/PrimerHR.vue'
import PrimerEvents from '../components/cluster-specific/PrimerEvents.vue'
import PrimerEservs from '../components/cluster-specific/PrimerEservs.vue'

export default {
  name: 'Clusters',
  components: {
      PrimerOSG,
      PrimerOET,
      PrimerComms,
      PrimerMarketing,
      PrimerHR,
      PrimerEvents,
      PrimerEservs
  },
  methods: {
    openTab: function (evt, clusterName) {
        // Declare all variables
        var i, tabcontent, tablinks;

        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }

        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        // Show the current tab, and add an "active" class to the button that opened the tab
        document.getElementById(clusterName).style.display = "block";
        // document.getElementById("osg-tab").className += " active";
        // document.getElementById(clusterButton).className += " active";
        evt.currentTarget.className += " active";

        }
    },

    mounted() {
        document.getElementById("defaultOpen").click();
    } 
  
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .clusters-page{
        margin: 56px 0px;
        padding-right: 6vw;
    }
    .cluster-nav{
        display: flex;
        flex-flow: row wrap;
    }

    .cluster-nav button {
        margin-right: 16px;
        height: 29px;
    }

    .tab {
        overflow: hidden; 
        margin-top: 16px;
    }

    .tab button {
        padding: 8px;
        font-weight: 600;
        font-size: 12px;
        margin-right: 18px;
        margin-top: 16px;
    }

    .active {
        background-color: #31A5AF;
        color: white;

        /* for testing */
        /* height: 42px;  */
    }

    .tabcontent {
        display: none;
    }

    h1{
        font-size: 3vw;
    }


    @media only screen and (max-width: 450px) {
        h1
        {
            font-size: 12px;
        }
    }


    /* Extra small devices (phones, 600px and down) */
    @media only screen and (min-width: 450px) {
        h1{
            font-size: 40px;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        h1{
            font-size: 48px;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        h1{
            font-size: 56px;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        h1{
            font-size: 64px;
        }
    }
</style>
